
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Loading from '@/components/loading/index.vue';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';

@Component({
  components: {
    Loading,
  },
})
export default class Individual extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  @Prop({ type: String, default: '' })
  type?: any;

  @Prop({ type: Array, default: [] })
  userModule?: any;

  ladoing = false;

  objList: any = {
    kaTeam: ['shouldBeCharged', 'promotionTong'],
    kaTeamLeader: ['shouldBeCharged', 'promotionTong'],
    kaTeamMinister: ['shouldBeCharged', 'promotionTong'],
    ordinaryTeam: ['shouldBeCharged', 'storeConsumed', 'mergePaymentIng', 'promotionTong'],
    ordinaryTeamLeader: ['shouldBeCharged', 'storeConsumed', 'mergePaymentIng', 'promotionTong'],
    ordinaryTeamMinister: ['shouldBeCharged', 'storeConsumed', 'mergePaymentIng', 'promotionTong'],
    assistantDirector: [],
    director: [],
  };


  dataObj: any = {
    ad_campaign_overflow: {
      data: '-', // 最多保留4位小数，替换成%，需要*100
      pass: true, // 是否合格，判断颜色展示
    },
    need_deployed: { // 合并支付投放完成
      data: true, // 是否合格，只有true和false
    },
    ad_campaign_recharge: { // 推广通完成率
      data: '-', // 最多保留4位小数，替换成%，需要*100
      pass: true, // 是否合格，判断颜色展示
    },
    ad_campaign_cost: { // 推广通消耗率
      data: '-', // 最多保留4位小数，替换成%，需要*100
      pass: true, // 是否合格，判断颜色展示
    },
    agent_gmv: { // 核销GMV完成率
      data: '-', // 最多保留4位小数，替换成%，需要*100
      pass: true, // 是否合格，判断颜色展示
    },
    activity_sign_cps: { // CPS标品活动完成率
      data: '-', // 最多保留4位小数，替换成%，需要*100
      pass: true, // 是否合格，判断颜色展示
    },
    shop_inspection_service: { // 服务巡检完成率
      data: '-', // 最多保留4位小数，替换成%，需要*100
      pass: true, // 是否合格，判断颜色展示
    },
    activity_sign_service: { // 服务标品活动完成率
      data: '-', // 最多保留4位小数，替换成%，需要*100
      pass: true, // 是否合格，判断颜色展示
    },
    ad_campaign_recharge_shop: { // 推广通充值门店完成率
      data: '-', // 最多保留4位小数，替换成%，需要*100
      pass: true, // 是否合格，判断颜色展示
    },
  };


  @Watch('type')
  WatchData() {
    // console.log(this.type);
    // const typeList = [
    //   'ordinaryTeamLeader',
    //   'kaTeamLeader',
    //   'ordinaryTeam',
    //   'kaTeam',
    // ];
    // console.log(typeList);
    // console.log(this.type, 'type');
    this.getMyList();
  }
  async getMyList() {
    try {
      const res = await this.workbenchesService.getMyAchievement();
      if (res) {
         this.ladoing = true;
        const { ad_campaign_overflow, need_deployed, ad_campaign_recharge, ad_campaign_cost, agent_gmv, activity_sign_cps, shop_inspection_service, activity_sign_service, ad_campaign_recharge_shop } = res;
        if (ad_campaign_overflow) {
          this.dataObj.ad_campaign_overflow = ad_campaign_overflow;
        }
        if (need_deployed) {
          this.dataObj.need_deployed = need_deployed;
        }
        if (ad_campaign_recharge) {
          this.dataObj.ad_campaign_recharge = ad_campaign_recharge;
        }
        if (ad_campaign_cost) {
          this.dataObj.ad_campaign_cost = ad_campaign_cost;
        }
        if (agent_gmv) {
          this.dataObj.agent_gmv = agent_gmv;
        }
        if (activity_sign_cps) {
          this.dataObj.activity_sign_cps = activity_sign_cps;
        }
        if (shop_inspection_service) {
          this.dataObj.shop_inspection_service = shop_inspection_service;
        }
        if (activity_sign_service) {
          this.dataObj.activity_sign_service = activity_sign_service;
        }
        if (ad_campaign_recharge_shop) {
          this.dataObj.ad_campaign_recharge_shop = ad_campaign_recharge_shop;
        }
      }
    } catch (error) {
      this.ladoing = true;
    }
  }

  convertNumber(val: any) {
    if (val === '-') return '-';
    return `${val * 100}%`;
  }
  mounted() {
    // console.log(this.type, 'lllllll');
    // this.getMyList();
    // getMyAchievement
  }
}
